import { AlertHexagonFillIcon } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import type { ConnectivityError as ConnectivityErrorType } from "@/shared/api/errors/ConnectivityError"
import styles from "./ConnectivityError.module.css"

interface ConnectivityErrorProps {
  error: ConnectivityErrorType | null
}

export function ConnectivityError({ error }: ConnectivityErrorProps) {
  const { t } = useTranslation()

  return (
    <div role="alert" className={styles.container}>
      <AlertHexagonFillIcon className={styles.icon} />
      <h1 className="fr-text-700">{t("vpnError.pageTitle")}</h1>
      <span className="fr-text-500">{t("vpnError.description")}</span>
      <div className={styles.steps}>
        <ol className={styles.stepsList}>
          <li>{t("vpnError.step1")}</li>
          <li>{t("vpnError.step2")}</li>
          <li>{t("vpnError.step3")}</li>
        </ol>
      </div>
      {error && (
        <details className={styles.errorDetails}>
          <summary className={styles.errorSummary}>{t("vpnError.technicalDetails")}</summary>
          <code className={styles.errorMessage}>{error.originalError.message}</code>
        </details>
      )}
    </div>
  )
}
